import {identity} from "./slices/identitySlice";
import {main, mainSlice} from "./slices/mainSlice";

const rootReducer = { identity: identity, main };

export default rootReducer
